import { useTranslation } from "react-i18next";
import { Badge } from "../../components/ui/card";

const TONES = {
  ready: "positive",
  succeeded: "positive",
  failed: "negative",
  insufficient: "warning",
  authoring: "neutral",
  queued: "neutral",
  running: "neutral",
} as const;

export function StatusBadge({ status, kind }: { status: keyof typeof TONES; kind: "program" | "run" }) {
  const { t } = useTranslation();
  return <Badge tone={TONES[status]}>{t(kind === "program" ? `programs.status.${status}` : `run.status.${status}`)}</Badge>;
}
